<template>
    <div>
        <div class="py-3 mb-3 border-bottom">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-6 d-flex">
                        <h5 class="m-0 p-0 align-self-center">
                            Tutoriais
                        </h5>
                    </div>
                    <div class="col-12 col-sm-6 text-left text-sm-right d-flex justify-content-end">

                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-2">
            <div class="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-4" >
                <div class="col mb-3" v-for="video, index in playlist" :key="index">

                    <b-card
                        class="link card-bg position-relative"
                        @click="showVideoModal(video)"
                    >
                        <b-card-img class="" :src="'https://img.youtube.com/vi/'+ video.id +'/hqdefault.jpg'">

                        </b-card-img>

                        <div class="text-video">
                            <h3 class="font-weight-bolder my-auto">Assistir agora</h3>
                        </div>

                        <b-card-title class="mt-3">
                            {{ video.title }}
                        </b-card-title>
                    </b-card>
                </div>

            </div>
        </div>

        <b-modal :title="file.title" class="" id="showVideo" hide-footer size="lg">
            <div class="iframe-area">
                <iframe class="iframe-responsive"  :src="file.url" title="YouTube video player" frameborder="0" allowfullscreen></iframe>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ['playlist'],
    data(){
        return {
            file: {}
        }
    },
    created(){
    },
    methods: {
        showVideoModal(video){
            this.file = video;
            this.$bvModal.show('showVideo');
        }
    },
}
</script>

<style>
    .iframe-area{
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        padding-top: 56.25%;
    }
    .iframe-responsive{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }

    .card-bg{
        cursor: pointer;
    }

    .card-bg:hover::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #03030391; /* Cor de fundo desejada, substitua pelo valor desejado */
        z-index: 5; /* Coloca o pseudoelemento abaixo do conteúdo da div */

    }
    .text-video{
        display: none;
    }


    .card-bg:hover .text-video{
        position: absolute;
        display: flex;
        visibility: visible;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: white;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 6;


        margin-block: auto;

    }


</style>
